import { useState } from 'react';
import { TableInput } from '../../../../../components/common';
import TBodyRight from './TBodyRight';
import formatDate from '../../../../../components/common/formatDate';
import { MenuItem } from '@mui/material';
import CustomSelect from '../../../../../components/common/SelectField';
import { DeleteIconButton } from '../../../../../components/common/button/CustomIconButton';
import AutocompleteMuiCustom from '../../../../../components/common/AutocompleteMuiCustom';

interface IProps {
  moduleData: any;
  allmonth: any;
  isView: boolean;
  tniTopic: any;
  handleDeleteRows: any;
  customerData: any;
  facultyData: any;
}
const TBody = ({
  moduleData,
  isView,
  allmonth,
  tniTopic,
  handleDeleteRows,
  customerData,
  facultyData,
}: IProps) => {
  const [render, setRender] = useState(false);
  return (
    <tbody>
      {moduleData?.list?.map((item: any, index: number) => (
        <>
          <tr key={`${index}_table_row`}>
            <td rowSpan={2}>{index + 1}</td>
            <td rowSpan={2}>
              {isView ? (
                item.a1
              ) : (
                <CustomSelect
                  name="a1"
                  value={item.a1}
                  onChange={(e) => {
                    item.a1 = e.target.value;
                    setRender((prev) => !prev);
                  }}
                >
                  <MenuItem value="">NONE</MenuItem>
                  {tniTopic.map((topic: any) => (
                    <MenuItem value={topic.name}>{topic.name}</MenuItem>
                  ))}
                </CustomSelect>
              )}
            </td>
            <td rowSpan={2}>
              {isView ? (
                item?.a2?.customer_name
              ) : (
                <AutocompleteMuiCustom
                  id="Customer"
                  label=""
                  option_name="customer_name"
                  arrayofObj={customerData}
                  value={item.a2_temp || item.a2 || ''}
                  onChange={(e, value) => {
                    item.a2 = value?._id;
                    item.a2_temp = value;
                    setRender((prev) => !prev);
                  }}
                />
              )}
            </td>
            <td rowSpan={2}>
              {isView ? (
                item?.a3?.faculty_name
              ) : (
                <AutocompleteMuiCustom
                  id="Faculty"
                  label=""
                  option_name="faculty_name"
                  arrayofObj={facultyData}
                  value={item.a3_temp || item.a3 || ''}
                  onChange={(e, value) => {
                    item.a3 = value?._id;
                    item.a3_temp = value;
                    setRender((prev) => !prev);
                  }}
                />
              )}
            </td>
            <td>P</td>
            {/* always constant ⬇️*/}
            <TBodyRight
              item={item}
              isView={isView}
              index={index}
              moduleData={moduleData}
            />
            <td rowSpan={2} style={{ minWidth: '100px', textAlign: 'center' }}>
              {!isView && (
                <DeleteIconButton
                  tooltipTitle={'delete'}
                  onClick={() => handleDeleteRows(index)}
                />
              )}
            </td>
          </tr>
          <tr>
            <td>A</td>
            {allmonth.map((month: any, mIdx: number) => (
              <td
                width="80px"
                height="45px"
                style={{
                  backgroundColor: item[month].doneDate && '#37b24d',
                  color: 'white',
                  textTransform: 'capitalize',
                  fontSize: '1.6rem',
                }}
              >
                {/* {item[month].isTask && 'A'} */}
                {formatDate(item[month].doneDate) || null}
              </td>
            ))}
          </tr>
          {/* ---x---- */}
        </>
      ))}
    </tbody>
  );
};

export default TBody;
